angular.module('forms').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/forms/views/completeForm.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-questionnaire\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <form name=\"completeQuestionnaireForm\" novalidate>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"questionnaire.questionnaireDetails.length\">\r" +
    "\n" +
    "                    <div class=\"panel-subheading-no-border-bottom\">\r" +
    "\n" +
    "                        <span>{{ ::questionnaire.questionnaireName }}&nbsp;&nbsp;completeForm.hgml</span>\r" +
    "\n" +
    "                        <span class=\"pull-right forms-sections-navigation\">\r" +
    "\n" +
    "                            {{ ::'Section' | translate}}\r" +
    "\n" +
    "                            {{ questionnaireSections.currentSectionNumber }}\r" +
    "\n" +
    "                            {{ ::'of' | translate}}\r" +
    "\n" +
    "                            {{ questionnaireSections.sections.length }}\r" +
    "\n" +
    "                            <span ng-if=\"questionnaireSections.sections.length > 1\">\r" +
    "\n" +
    "                                <span class=\"clickable prev-nav\" ng-click=\"navMovePrevious()\">{{::'Prev' | translate}}</span>\r" +
    "\n" +
    "                                <span ng-repeat=\"section in questionnaireSections.sections | filter: { Visible: true }\">\r" +
    "\n" +
    "                                    <span class=\"clickable section-numbers\"\r" +
    "\n" +
    "                                          ng-click=\"displaySection(section)\">{{ section.SectionNumber }}\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                                <span class=\"clickable next-nav\" type=\"submit\" ng-click=\"navMoveNext()\">{{::'Next' | translate}}</span>\r" +
    "\n" +
    "                            </span>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <!-- <div class=\"forms-padding-top-10\"></div> -->\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"panel-subheading\">\r" +
    "\n" +
    "                        {{ questionnaireSections.currentSectionNumber }}.\r" +
    "\n" +
    "                        &nbsp;\r" +
    "\n" +
    "                        {{ questionnaireSections.currentSectionName }}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"row row-question form-group\"\r" +
    "\n" +
    "                         ng-repeat=\"question in questionnaireSections.sections[questionnaireSections.currentSectionNumber - 1].Questions\"\r" +
    "\n" +
    "                         ng-class=\"{ 'has-error': (completeQuestionnaireForm['SurveyQuestionId_'+question.SurveyQuestionId].$invalid\r" +
    "\n" +
    "                                                        && (completeQuestionnaireForm['SurveyQuestionId_'+question.SurveyQuestionId].$dirty\r" +
    "\n" +
    "                                                                || completeQuestionnaireForm.isSubmitted))}\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <ap-form-question question=\"question\" form=\"completeQuestionnaireForm\"></ap-form-question>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div ng-switch=\"(question.SurveyControlTypeName | uppercase)\">\r" +
    "\n" +
    "                            <div ng-switch-when=\"RADIOBUTTON\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-4 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                    <ap-form-answer-radiobutton question=\"question\" answer=\"answer\" form=\"completeQuestionnaireForm\"></ap-form-answer-radiobutton>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"CHECKBOX\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-4 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                    <ap-form-answer-checkbox question=\"question\" answer=\"answer\"></ap-form-answer-checkbox>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"TEXT\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                    <ap-form-answer-text question=\"question\" answer=\"answer\"></ap-form-answer-text>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"TIMEFRAME\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                    <ap-form-answer-timeframe question=\"question\"></ap-form-answer-timeframe>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"NUMERIC\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                    <ap-form-answer-numeric question=\"question\"></ap-form-answer-numeric>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                            <div ng-switch-when=\"DATE\" class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                    <ap-form-answer-date question=\"question\"></ap-form-answer-date>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"forms-footer\">\r" +
    "\n" +
    "                        <button id=\"finish-later-btn\" class=\"btn btn-default2 pull-left\" data-transition-to=\"{appRoute: 'forms'}\">\r" +
    "\n" +
    "                            {{:: 'Finish later' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <button id=\"next-section-btn\" type=\"submit\" name=\"next_section_btn\" class=\"btn btn-primary pull-right\" ng-click=\"navMoveNext()\">\r" +
    "\n" +
    "                            {{::'Next : ' | translate}} &nbsp; {{questionnaireSections.nextSectionName}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div id=\"no-questionnaire-details-div\"\r" +
    "\n" +
    "                     class=\"text-center\"\r" +
    "\n" +
    "                     ng-if=\"!questionnaire.questionnaireDetails.length\">\r" +
    "\n" +
    "                        {{::'Questionnaire was not found.' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        </form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient questionnaire could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to view patient questionnaires.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/confirmForm.html',
    "<div class=\"panel panel-questionnaire\">\r" +
    "\n" +
    "    <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-heading-confirm-forms\">\r" +
    "\n" +
    "            {{::'Your form has been submitted.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-confirm\">\r" +
    "\n" +
    "            {{::'Thank you for filling out your ' | translate}} {{::questionnaire.questionnaireName}} {{::' form.  These details'}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-confirm\">\r" +
    "\n" +
    "            {{::'have been added to your account and will help us provide you' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"text-confirm ap-margin-bottom-30\">\r" +
    "\n" +
    "            {{::'more tailored care.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"text-center\">\r" +
    "\n" +
    "            <button id=\"done-btn\" class=\"btn btn-primary\" data-transition-to=\"{appRoute: 'forms'}\">\r" +
    "\n" +
    "                {{::'Done' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "        <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "            <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "            {{::'An error has occurred and the patient questionnaire could not be loaded.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "            {{::'You do not have access to view patient questionnaires.' | translate}}\r" +
    "\n" +
    "        </uib-alert>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerCheckbox.html',
    "<span class=\"pull-left answer-control\" ng-init=\"cbControlId = 'cbSurveyAnswerId_' + answer.SurveySectionId + '_' + answer.SurveyQuestionId + '_' + answer.SurveyAnswerId\">\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "    <input class=\"form-control\"\r" +
    "\n" +
    "           type=\"checkbox\"\r" +
    "\n" +
    "           name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}\"\r" +
    "\n" +
    "           id=\"{{cbControlId}}\"\r" +
    "\n" +
    "           ng-model=\"answer.SelectedAnswer\"\r" +
    "\n" +
    "           ng-change=\"answerChanged()\"\r" +
    "\n" +
    "           ng-disabled=\"!question.QuestionEnabled\"/>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <label ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\" for=\"{{cbControlId}}\"></label>\r" +
    "\n" +
    "    <label ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\" for=\"{{cbControlId}}\">\r" +
    "\n" +
    "        &nbsp;&nbsp;{{answer.SurveyAnswerLabel}}\r" +
    "\n" +
    "    </label>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "    <label class=\"label_wrap\" for=\"{{cbControlId}}\">\r" +
    "\n" +
    "        <input type=\"checkbox\"\r" +
    "\n" +
    "               class=\"form-control\"\r" +
    "\n" +
    "               name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}\"\r" +
    "\n" +
    "               id=\"{{cbControlId}}\"\r" +
    "\n" +
    "               ng-model=\"answer.SelectedAnswer\"\r" +
    "\n" +
    "               ng-change=\"answerChanged()\"\r" +
    "\n" +
    "               ng-disabled=\"!question.QuestionEnabled\"/>\r" +
    "\n" +
    "        <span ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\">&nbsp;&nbsp;{{answer.SurveyAnswerLabel}}</span>\r" +
    "\n" +
    "    </label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"(answer.SurveyRequiresExplanation)\"\r" +
    "\n" +
    "         class=\"answer-control-explanation\"\r" +
    "\n" +
    "         ng-class=\"{ 'has-error' : form['SurveyQuestionId_' + answer.SurveyQuestionId + '_SurveyAnswerId_' + answer.SurveyAnswerId + '_Explanation'].$invalid && form.isSubmitted}\">\r" +
    "\n" +
    "        <textarea\r" +
    "\n" +
    "                class=\"form-control\"\r" +
    "\n" +
    "                name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}_SurveyAnswerId_{{answer.SurveyAnswerId}}_Explanation\"\r" +
    "\n" +
    "                id=\"{{cbControlId}}_Explanation\"\r" +
    "\n" +
    "                ng-model=\"answer.SurveyExplanation\"\r" +
    "\n" +
    "                placeholder=\"{{ explanationPlaceHolder.Text }}\"\r" +
    "\n" +
    "                rows=\"2\"\r" +
    "\n" +
    "                ng-change=\"explanationTextChanged()\"\r" +
    "\n" +
    "                ng-required=\"(answer.SelectedAnswer === true)\"\r" +
    "\n" +
    "                ng-disabled=\"(answer.SelectedAnswer === false)\">\r" +
    "\n" +
    "        </textarea>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</span>"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerDate.html',
    "<p class=\"input-group\" ng-init=\"diControlId = 'diControlId_' + question.SurveySectionId + '_' + question.SurveyQuestionId\">\r" +
    "\n" +
    "    <input type=\"text\"\r" +
    "\n" +
    "           class=\"form-control\"\r" +
    "\n" +
    "           name=\"SurveyQuestionId_{{question.SurveyQuestionId}}\"\r" +
    "\n" +
    "           id=\"{{diControlId}}\"\r" +
    "\n" +
    "           placeholder=\"{{:: 'Click to select date' | translate}}\"\r" +
    "\n" +
    "           ng-model=\"question.SelectedAnswerText\"\r" +
    "\n" +
    "           ng-click=\"openDatePicker($event)\"\r" +
    "\n" +
    "           is-open=\"datePopup.Opened\"\r" +
    "\n" +
    "           min-date=\"minDate\"\r" +
    "\n" +
    "           max-date=\"maxDate\"\r" +
    "\n" +
    "           current-text=\"Today\"\r" +
    "\n" +
    "           clear-text=\"Clear\"\r" +
    "\n" +
    "           close-text=\"Close\"\r" +
    "\n" +
    "           show-button-bar=\"true\"\r" +
    "\n" +
    "           close-on-date-selection=\"true\"\r" +
    "\n" +
    "           on-open-focus=\"true\"\r" +
    "\n" +
    "           uib-datepicker-popup=\"MMMM dd, yyyy\"\r" +
    "\n" +
    "           ng-required=\"(question.QuestionEnabled && question.QuestionRequireAnswer)\"\r" +
    "\n" +
    "           ng-readonly=\"true\">\r" +
    "\n" +
    "    <span class=\"input-group-btn\">\r" +
    "\n" +
    "        <button type=\"button\" class=\"btn btn-default\" ng-click=\"openDatePicker($event)\"><i class=\"fa fa-calendar\"></i></button>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</p>"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerNumeric.html',
    "<span ng-init=\"niControlId = 'niControlId_' + question.SurveySectionId + '_' + question.SurveyQuestionId\">\r" +
    "\n" +
    "    <input class=\"form-control\"\r" +
    "\n" +
    "           type=\"number\"\r" +
    "\n" +
    "           name=\"SurveyQuestionId_{{question.SurveyQuestionId}}\"\r" +
    "\n" +
    "           id=\"{{niControlId}}\"\r" +
    "\n" +
    "           ng-model=\"question.SelectedAnswerText\"\r" +
    "\n" +
    "           placeholder=\"{{ ::'Answer here' | translate}}\"\r" +
    "\n" +
    "           ng-blur=\"answerChanged()\"\r" +
    "\n" +
    "           ng-required=\"(question.QuestionEnabled && question.QuestionRequireAnswer)\"\r" +
    "\n" +
    "           ng-disabled=\"!question.QuestionEnabled\">\r" +
    "\n" +
    "</span>\r" +
    "\n" +
    "<div class=\"answer-numeric-further-information\">{{'Please enter a number' | translate}}</div>"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerRadiobutton.html',
    "<span class=\"pull-left answer-control\" ng-init=\"rbControlId = 'rbSurveyAnswerId_' + answer.SurveySectionId + '_' + answer.SurveyQuestionId + '_' + answer.SurveyAnswerId\">\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "    <input class=\"form-control\"\r" +
    "\n" +
    "           type=\"radio\"\r" +
    "\n" +
    "           name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}\"\r" +
    "\n" +
    "           id=\"{{rbControlId}}\"\r" +
    "\n" +
    "           ng-model=\"question.SelectedAnswerId\"\r" +
    "\n" +
    "           ng-value=\"answer.SurveyAnswerId\"\r" +
    "\n" +
    "           ng-change=\"answerChanged()\"\r" +
    "\n" +
    "           ng-required=\"(!question.SectionOptional && !question.QuestionOptional)\"\r" +
    "\n" +
    "           ng-disabled=\"!question.QuestionEnabled\"/>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <label for=\"{{rbControlId}}\" ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\"></label>\r" +
    "\n" +
    "    <label for=\"{{rbControlId}}\" ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\">\r" +
    "\n" +
    "        &nbsp;&nbsp;{{answer.SurveyAnswerLabel}}\r" +
    "\n" +
    "    </label>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "    <div class=\"label_wrap ap-radio-wrapper ap-radio-tight\">\r" +
    "\n" +
    "        <input class=\"form-control\"\r" +
    "\n" +
    "               type=\"radio\"\r" +
    "\n" +
    "               name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}\"\r" +
    "\n" +
    "               id=\"{{rbControlId}}\"\r" +
    "\n" +
    "               ng-model=\"question.SelectedAnswerId\"\r" +
    "\n" +
    "               ng-value=\"answer.SurveyAnswerId\"\r" +
    "\n" +
    "               ng-change=\"answerChanged()\"\r" +
    "\n" +
    "               ap-required=\"( (question.QuestionEnabled && question.QuestionRequireAnswer) )\"\r" +
    "\n" +
    "               ng-disabled=\"!question.QuestionEnabled\"/>\r" +
    "\n" +
    "        <label for=\"{{rbControlId}}\" ng-class=\"(question.QuestionEnabled) ? 'control-enabled' : 'control-disabled'\">{{answer.SurveyAnswerLabel}}</label>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div ng-if=\"(answer.SurveyRequiresExplanation && (question.SelectedAnswerId === answer.SurveyAnswerId))\"\r" +
    "\n" +
    "         class=\"answer-control-explanation\"\r" +
    "\n" +
    "         ng-class=\"{ 'has-error' : !question.RequiredFieldsPopulated && form.isSubmitted}\">\r" +
    "\n" +
    "        <label hidden for=\"{{rbControlId}}_Explanation\">{{'Explanation' | translate}}</label>\r" +
    "\n" +
    "        <textarea\r" +
    "\n" +
    "            class=\"form-control\"\r" +
    "\n" +
    "            name=\"SurveyQuestionId_{{answer.SurveyQuestionId}}_ExplanationRequired\"\r" +
    "\n" +
    "            id=\"{{rbControlId}}_Explanation\"\r" +
    "\n" +
    "            ng-model=\"answer.SurveyExplanation\"\r" +
    "\n" +
    "            placeholder=\"{{ 'Required Explanation here' | translate }}\"\r" +
    "\n" +
    "            rows=\"2\"\r" +
    "\n" +
    "            ng-change=\"explanationTextChanged()\"\r" +
    "\n" +
    "            ap-required=\"(question.SelectedAnswerId === answer.SurveyAnswerId) && (answer.SurveyRequiresExplanation)\"\r" +
    "\n" +
    "            ng-disabled=\"(question.SelectedAnswerId !== answer.SurveyAnswerId)\">\r" +
    "\n" +
    "        </textarea>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</span>\r" +
    "\n"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerText.html',
    "<span ng-init=\"taControlId = 'taControlId' + question.SurveySectionId + '_' + question.SurveyQuestionId\">\r" +
    "\n" +
    "    <label hidden for=\"{{taControlId}}\">{{'Answer Here' | translate}}</label>\r" +
    "\n" +
    "    <textarea\r" +
    "\n" +
    "        class=\"form-control\"\r" +
    "\n" +
    "        name=\"SurveyQuestionId_{{question.SurveyQuestionId}}\"\r" +
    "\n" +
    "        id=\"{{taControlId}}\"\r" +
    "\n" +
    "        ng-model=\"question.SelectedAnswerText\"\r" +
    "\n" +
    "        placeholder=\"{{ ::'Answer here' | translate}}\"\r" +
    "\n" +
    "        ng-blur=\"answerChanged()\"\r" +
    "\n" +
    "        ng-required=\"(question.QuestionEnabled && question.QuestionRequireAnswer)\"\r" +
    "\n" +
    "        rows=\"5\"\r" +
    "\n" +
    "        ng-disabled=\"!question.QuestionEnabled\">\r" +
    "\n" +
    "    </textarea>\r" +
    "\n" +
    "</span>"
  );


  $templateCache.put('/forms/views/directives/apFormAnswerTimeframe.html',
    "<div class=\"row-answer\" ng-init=\"tfControlId = 'tfControlId_' + question.SurveySectionId + '_' + question.SurveyQuestionId\">\r" +
    "\n" +
    "    <span ng-class=\"(question.QuestionEnabled) ? 'text-enabled' : 'text-disabled'\">{{ :: 'Time Frame:' | translate }}</span>\r" +
    "\n" +
    "    &nbsp;&nbsp;\r" +
    "\n" +
    "        <input class=\"form-control\"\r" +
    "\n" +
    "               type=\"text\"\r" +
    "\n" +
    "               name=\"SurveyQuestionId_{{question.SurveyQuestionId}}_QuestionRequired\"\r" +
    "\n" +
    "               id=\"{{tfControlId}}\"\r" +
    "\n" +
    "               ng-model=\"question.SelectedAnswerText\"\r" +
    "\n" +
    "               placeholder=\"{{ (question.QuestionEnabled && question.QuestionRequireAnswer) ? timeframeText.TextPlaceHolder : timeframeText.TextPlaceHolderRequired }}\"\r" +
    "\n" +
    "               ng-blur=\"answerChanged()\"\r" +
    "\n" +
    "               ap-required=\"question.QuestionEnabled && question.QuestionRequireAnswer\"\r" +
    "\n" +
    "               ng-disabled=\"!question.QuestionEnabled\">\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row-answer\">\r" +
    "\n" +
    "    <span ng-class=\"(question.QuestionEnabled) ? 'text-enabled' : 'text-disabled'\">{{ :: 'Please select the time format for your answer.' | translate}}</span>\r" +
    "\n" +
    "    <div class=\"row-answer\">\r" +
    "\n" +
    "        <fieldset>\r" +
    "\n" +
    "            <div class=\"col-xs-4 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                <ap-form-answer-radiobutton question=\"question\" answer=\"answer\" selected-button-callback=\"selectedButtonCallback(selectedUid)\"></ap-form-answer-radiobutton>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </fieldset>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );


  $templateCache.put('/forms/views/directives/apFormQuestion.html',
    "<label ng-class=\"(question.QuestionEnabled) ? 'text-question-enabled' : 'text-question-disabled'\">\r" +
    "\n" +
    "    {{ question.QuestionNumber }}.&nbsp;&nbsp;{{ question.SurveyQuestionLabel }}\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span class=\"forms-question-validation-error\" ng-if=\"!question.QuestionEnabled\">{{'Question Disabled' | translate}}</span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-if=\"(\r" +
    "\n" +
    "                    (question.QuestionEnabled && question.QuestionRequireAnswer)\r" +
    "\n" +
    "                 )\"\r" +
    "\n" +
    "          ng-class=\"{ 'has-error control-label' : (!question.RequiredFieldsPopulated || form['SurveyQuestionId_'+ question.SurveyQuestionId].$invalid) && form.isSubmitted}\">\r" +
    "\n" +
    "        &nbsp;<span class=\"fa fa-asterisk\"></span>\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <span ng-if=\"(  (question.QuestionEnabled && question.QuestionRequireAnswer && (form['SurveyQuestionId_'+ question.SurveyQuestionId].$invalid || !question.RequiredFieldsPopulated)\r" +
    "\n" +
    "                        && (form.isSubmitted || form['SurveyQuestionId_' + question.SurveyQuestionId].$dirty || !question.RequiredFieldsPopulated))\r" +
    "\n" +
    "                      ||\r" +
    "\n" +
    "                    (question.QuestionEnabled && question.QuestionRequireAnswer && form['SurveyQuestionId_'+ question.SurveyQuestionId + '_QuestionRequired'].$invalid\r" +
    "\n" +
    "                         && (form.isSubmitted || form['SurveyQuestionId_' + question.SurveyQuestionId + '_QuestionRequired'].$dirty))\r" +
    "\n" +
    "                 )\"\r" +
    "\n" +
    "          class=\"control-label forms-question-validation-error\"\r" +
    "\n" +
    "          ng-class=\"{ 'has-error' : !question.RequiredFieldsPopulated && form.isSubmitted}\">\r" +
    "\n" +
    "        {{ 'Please enter required field.' | translate}}\r" +
    "\n" +
    "    </span>\r" +
    "\n" +
    "</label>"
  );


  $templateCache.put('/forms/views/directives/apFormQuestionFamilyHistory.html',
    "<label class=\"text-question-enabled\">\r" +
    "\n" +
    "    {{ 'Please enter family history' | translate }}\r" +
    "\n" +
    "</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"row-item col-xs-12\">\r" +
    "\n" +
    "        <div class=\"col-xs-3 col-flush\"></div>\r" +
    "\n" +
    "        <div class=\"col-xs-3 col-flush\"></div>\r" +
    "\n" +
    "        <div class=\"col-xs-4 col-flush\"></div>\r" +
    "\n" +
    "        <div class=\"col-xs-2 col-flush\">\r" +
    "\n" +
    "            <button class=\"btn btn-default1 pull-right\" ng-click=\"addFamilyHistoryInformation()\">\r" +
    "\n" +
    "                {{::'Add Family History' | translate}}\r" +
    "\n" +
    "            </button>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"row-item col-xs-12\">\r" +
    "\n" +
    "        <div class=\"col-xs-3 col-flush\">\r" +
    "\n" +
    "            {{:: 'Relationship' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-3 col-flush\">\r" +
    "\n" +
    "            {{:: 'Name' | translate }}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-4 col-flush\">\r" +
    "\n" +
    "            {{::'Disease' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "        <div class=\"col-xs-2 col-flush\"></div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"body-line col-xs-12\">\r" +
    "\n" +
    "        <div ng-if=\"!questionnaireSection.FamilyHistoryAnswers.length\">\r" +
    "\n" +
    "            {{:: 'Please enter family history.' | translate}}\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"striped col-xs-12\" ng-repeat=\"familyHistoryAnswer in questionnaireSection.FamilyHistoryAnswers\">\r" +
    "\n" +
    "            <div class=\"col-xs-3 col-flush\">\r" +
    "\n" +
    "                {{familyHistoryAnswer.RelationshipName}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-3 col-flush\">\r" +
    "\n" +
    "                {{familyHistoryAnswer.FirstName}} {{familyHistoryAnswer.LastName}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-4 col-flush\">\r" +
    "\n" +
    "                <div ng-repeat=\"problemHistoryAnswer in familyHistoryAnswer.ProblemHistoryAnswers | filter: {Selected: 'true'}\">\r" +
    "\n" +
    "                    {{problemHistoryAnswer.DiseaseName}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"col-xs-2 col-flush center-text\">\r" +
    "\n" +
    "                <button class=\"btn btn-default1\" ng-click=\"EditFamilyHistoryAnswer(familyHistoryAnswer)\">\r" +
    "\n" +
    "                    {{'Edit' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <button class=\"btn btn-default1\" ng-click=\"DeleteFamilyHistoryAnswer(familyHistoryAnswer)\">\r" +
    "\n" +
    "                    {{'Delete' | translate}}\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/forms/views/directives/apFormQuestionImmunizationHistory.html',
    "\r" +
    "\n" +
    "<div ng-if=\"adultVaccineList.length\">\r" +
    "\n" +
    "    <label class=\"text-question-enabled\">\r" +
    "\n" +
    "        {{ 'Please enter an onset date for each adult immunization you have had.' | translate }}\r" +
    "\n" +
    "    </label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"history-primary\">\r" +
    "\n" +
    "        <div class=\"history-body\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row ap-margin-bottom-30\">\r" +
    "\n" +
    "                <div class=\"row-item col-xs-12 col-flush\">\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-striped-left\">\r" +
    "\n" +
    "                        <span class=\"pull-left\">\r" +
    "\n" +
    "                            <label class=\"label-text\">{{::'Adult Immunization' | translate}}</label>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-striped-right\">\r" +
    "\n" +
    "                        <span class=\"pull-right\">\r" +
    "\n" +
    "                            <label class=\"label-text\">{{::'Onset Date' | translate}}</label>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"body-line col-xs-12\">\r" +
    "\n" +
    "                    <div ng-if=\"!adultVaccineList.length\">\r" +
    "\n" +
    "                        {{::'There are no adult immunizations associated with Patient Immunization History section.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-flush\" ng-repeat=\"immunizationsAdult in questionnaireSection.ImmunizationHistoryAnswers.ImmunizationAdultAnswers\">\r" +
    "\n" +
    "                        <div class=\"striped col-xs-12 col-flush\" ng-repeat=\"immunizationAnswer in immunizationsAdult.ImmunizationAnswers\">\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                    <input type=\"checkbox\"\r" +
    "\n" +
    "                                           class=\"form-control\"\r" +
    "\n" +
    "                                           name=\"adult_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                           id=\"adult_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                           ng-model=\"immunizationAnswer.Selected\">\r" +
    "\n" +
    "                                    <label class=\"label-text\" for=\"adult_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\">&nbsp;&nbsp;{{ immunizationAnswer.VaccineName }}</label>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                                    <ap-time-frame\r" +
    "\n" +
    "                                            time-frame-id=\"immunizationsAdult.VaccineAdminId + '_' + immunizationAnswer.VaccineAdminItemId\"\r" +
    "\n" +
    "                                            time-frame-answer=\"immunizationAnswer.OnsetTimeFrame\"\r" +
    "\n" +
    "                                            time-frame-selected-callback=\"adultTimeFrameSelectedCallback(timeFrameId,onsetTimeFrameId)\"\r" +
    "\n" +
    "                                            required>\r" +
    "\n" +
    "                                    </ap-time-frame>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"row form-group\">\r" +
    "\n" +
    "                                        <label class=\"control-label\">{{:: 'Notes' | translate}}</label>\r" +
    "\n" +
    "                                        <textarea\r" +
    "\n" +
    "                                                class=\"form-control\"\r" +
    "\n" +
    "                                                id=\"notes_adult_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                                name=\"notes_adult_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                                ng-model=\"immunizationAnswer.Notes\"\r" +
    "\n" +
    "                                                placeholder=\"{{ ::'Notes here' | translate }}\"\r" +
    "\n" +
    "                                                rows=\"1\">\r" +
    "\n" +
    "                                        </textarea>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div ng-if=\"pediatricVaccineList.length\">\r" +
    "\n" +
    "    <label class=\"text-question-enabled\">\r" +
    "\n" +
    "        {{ 'Please enter an onset date for each pediatric immunization you have had.' | translate }}\r" +
    "\n" +
    "    </label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <div class=\"history-primary\">\r" +
    "\n" +
    "        <div class=\"history-body\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"row-item col-xs-12 col-flush\">\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-striped-left\">\r" +
    "\n" +
    "                        <span class=\"pull-left\">\r" +
    "\n" +
    "                            <label class=\"label-text\">{{::'Pediatric Immunization' | translate}}</label>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-6 col-striped-right\">\r" +
    "\n" +
    "                        <span class=\"pull-right\">\r" +
    "\n" +
    "                            <label class=\"label-text\">{{::'Onset Date' | translate}}</label>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"body-line col-xs-12\">\r" +
    "\n" +
    "                    <div ng-if=\"!pediatricVaccineList.length\">\r" +
    "\n" +
    "                        {{::'There are no pediatric immunizations associated with Patient Immunization History section.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-flush\" ng-repeat=\"immunizationsPediatric in questionnaireSection.ImmunizationHistoryAnswers.ImmunizationPediatricAnswers\">\r" +
    "\n" +
    "                        <div class=\"striped col-xs-12 col-flush\" ng-repeat=\"immunizationAnswer in immunizationsPediatric.ImmunizationAnswers\">\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                    <input type=\"checkbox\"\r" +
    "\n" +
    "                                           class=\"form-control\"\r" +
    "\n" +
    "                                           name=\"pediatric_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                           id=\"pediatric_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                           ng-model=\"immunizationAnswer.Selected\">\r" +
    "\n" +
    "                                    <label class=\"label-text\" for=\"pediatric_immunization_selected_{{immunizationAnswer.VaccineAdminItemId}}\">&nbsp;&nbsp;{{ immunizationAnswer.VaccineName }}</label>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                                    <ap-time-frame\r" +
    "\n" +
    "                                        time-frame-id=\"immunizationsPediatric.VaccineAdminId + '_' + immunizationAnswer.VaccineAdminItemId\"\r" +
    "\n" +
    "                                        time-frame-answer=\"immunizationAnswer.OnsetTimeFrame\"\r" +
    "\n" +
    "                                        time-frame-selected-callback=\"pediatricTimeFrameSelectedCallback(timeFrameId,onsetTimeFrameId)\"\r" +
    "\n" +
    "                                        required>\r" +
    "\n" +
    "                                    </ap-time-frame>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"row form-group\">\r" +
    "\n" +
    "                                        <label class=\"control-label\">{{:: 'Notes' | translate}}</label>\r" +
    "\n" +
    "                                        <textarea\r" +
    "\n" +
    "                                                class=\"form-control\"\r" +
    "\n" +
    "                                                id=\"notes_pediatric_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                                name=\"notes_pediatric_{{immunizationAnswer.VaccineAdminItemId}}\"\r" +
    "\n" +
    "                                                ng-model=\"immunizationAnswer.Notes\"\r" +
    "\n" +
    "                                                placeholder=\"{{ ::'Notes here' | translate }}\"\r" +
    "\n" +
    "                                                rows=\"1\">\r" +
    "\n" +
    "                                        </textarea>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/directives/apFormQuestionPatientProblemHistory.html',
    "<label class=\"text-question-enabled\">\r" +
    "\n" +
    "    {{ ::'Please enter an onset date for each disease that you have had.' | translate }}\r" +
    "\n" +
    "</label>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"history-primary\">\r" +
    "\n" +
    "    <div class=\"history-body\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"row\">\r" +
    "\n" +
    "            <div class=\"row-item col-xs-12 col-flush\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-striped-left\">\r" +
    "\n" +
    "                    <span class=\"pull-left\">\r" +
    "\n" +
    "                        <label class=\"label-text\">{{:: 'Disease' | translate}}</label>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-striped-right\">\r" +
    "\n" +
    "                    <span class=\"pull-right\">\r" +
    "\n" +
    "                        <label class=\"label-text\">{{:: 'Onset Date' | translate}}</label>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"col-xs-12 body-line\">\r" +
    "\n" +
    "                <div ng-if=\"!findTableItemsProblemHx.length &&  !questionnaireSection.ProblemHistoryAnswers.length\">\r" +
    "\n" +
    "                    {{::'There are no diseases associated with Patient Problem History section.' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"striped col-xs-12 col-flush\" ng-repeat=\"problemHistoryAnswer in questionnaireSection.ProblemHistoryAnswers\">\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                            <input type=\"checkbox\"\r" +
    "\n" +
    "                                   class=\"form-control\"\r" +
    "\n" +
    "                                   name=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                   id=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                   ng-model=\"problemHistoryAnswer.Selected\"\r" +
    "\n" +
    "                                   ng-disabled=\"problemHistoryAnswer.CameFromPatientChart\">\r" +
    "\n" +
    "                            <label class=\"label-text\" \r" +
    "\n" +
    "                                   ng-class=\"problemHistoryAnswer.CameFromPatientChart ? 'disabled' : ''\"\r" +
    "\n" +
    "                                   for=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\">&nbsp;&nbsp;{{ problemHistoryAnswer.DiseaseName }}</label>\r" +
    "\n" +
    "                            <span ng-show=\"problemHistoryAnswer.CameFromPatientChart\">&nbsp;{{'(Already On Chart)' | translate}}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                            <ap-time-frame\r" +
    "\n" +
    "                                    time-frame-id=\"problemHistoryAnswer.ProblemHistoryAnswerId\"\r" +
    "\n" +
    "                                    time-frame-answer=\"problemHistoryAnswer.OnsetTimeFrame\"\r" +
    "\n" +
    "                                    time-frame-selected-callback=\"timeFrameSelectedCallback(timeFrameId,onsetTimeFrameId)\"\r" +
    "\n" +
    "                                    disabled=\"problemHistoryAnswer.CameFromPatientChart\"\r" +
    "\n" +
    "                                    required>\r" +
    "\n" +
    "                            </ap-time-frame>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                            <div class=\"row form-group\">\r" +
    "\n" +
    "                                <label class=\"control-label\">{{:: 'Notes' | translate}}</label>\r" +
    "\n" +
    "                                <textarea\r" +
    "\n" +
    "                                        class=\"form-control\"\r" +
    "\n" +
    "                                        id=\"notes_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                        name=\"notes_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                        ng-model=\"problemHistoryAnswer.Notes\"\r" +
    "\n" +
    "                                        placeholder=\"{{ ::'Notes here' | translate }}\"\r" +
    "\n" +
    "                                        ng-disabled=\"problemHistoryAnswer.CameFromPatientChart\"\r" +
    "\n" +
    "                                        rows=\"1\">\r" +
    "\n" +
    "                                </textarea>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n"
  );


  $templateCache.put('/forms/views/directives/apTimeFrame.html',
    "\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-2 col-flush\"></div>\r" +
    "\n" +
    "    <div class=\"col-xs-4 col-flush\">showDatePicker = {{ datePickerModel.showDatePicker ? 'hello' : 'goodbye' }}</div>\r" +
    "\n" +
    "    <div class=\"col-xs-6 col-flush\"></div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\">\r" +
    "\n" +
    "    <div class=\"col-xs-2 col-flush\"></div>\r" +
    "\n" +
    "    <div class=\"col-xs-4 col-flush\">\r" +
    "\n" +
    "        <input ng-if=\"timeFrameInputIsVisible\"\r" +
    "\n" +
    "               class=\"form-control\"\r" +
    "\n" +
    "               id=\"{{tfInputCtrlId}}\"\r" +
    "\n" +
    "               name=\"{{tfInputCtrlId}}\"\r" +
    "\n" +
    "               ng-model=\"timeFrameAnswer.OnsetTimeFrameValue\"\r" +
    "\n" +
    "               type=\"number\"\r" +
    "\n" +
    "               ng-min=\"1\"\r" +
    "\n" +
    "               ng-max=\"99\"\r" +
    "\n" +
    "               ng-maxlength=\"2\"\r" +
    "\n" +
    "               placeholder=\"{{:: 'Number of ' | translate}}\"\r" +
    "\n" +
    "               ng-required=\"true\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <input ng-if=\"calendarInputIsVisible\"\r" +
    "\n" +
    "               class=\"form-control\"\r" +
    "\n" +
    "               name=\"{{calInputCtrlId}}\"\r" +
    "\n" +
    "               id=\"{{calInputCtrlId}}\"\r" +
    "\n" +
    "               ng-model=\"timeFrameAnswer.OnsetTimeFrameDate\"\r" +
    "\n" +
    "               ng-click=\"datePickerModel.showDatePicker=true\"\r" +
    "\n" +
    "               is-open=\"datePickerModel.showDatePicker ? true : false\"\r" +
    "\n" +
    "               min-date=\"minDate\"\r" +
    "\n" +
    "               max-date=\"maxDate\"\r" +
    "\n" +
    "               current-text=\"Today\"\r" +
    "\n" +
    "               clear-text=\"Clear\"\r" +
    "\n" +
    "               close-text=\"Done\"\r" +
    "\n" +
    "               show-button-bar=\"false\"\r" +
    "\n" +
    "               close-on-date-selection=\"true\"\r" +
    "\n" +
    "               on-open-focus=\"true\"\r" +
    "\n" +
    "               uib-datepicker-popup=\"MMM dd, yyyy\"\r" +
    "\n" +
    "               ng-required=\"true\"\r" +
    "\n" +
    "               ng-readonly=\"true\"\r" +
    "\n" +
    "               ng-change=\"datePickerChanged()\"\r" +
    "\n" +
    "               type=\"text\">\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "    <div class=\"col-xs-6 col-flush\">\r" +
    "\n" +
    "            <select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                    ng-disabled=\"disabled\"\r" +
    "\n" +
    "                    name=\"{{tfSelCtrlId}}\"\r" +
    "\n" +
    "                    id=\"{{tfSelCtrlId}}\"\r" +
    "\n" +
    "                    ng-model=\"timeFrameAnswer.OnsetTimeFrameId\"\r" +
    "\n" +
    "                    ng-change=\"timeFrameTypeChanged()\"\r" +
    "\n" +
    "                    ng-options=\"timeFrameType.TimeFrameId as timeFrameType.Name for timeFrameType in timeFrameTypes\"\r" +
    "\n" +
    "                    ap-set-focus-event=\"change\"\r" +
    "\n" +
    "                    ap-set-focus-id=\"{{tfInputCtrlId}}\">\r" +
    "\n" +
    "            </select>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\" ng-if=\"formRef[tfInputCtrlId].$error && formRef.isSubmitted\">\r" +
    "\n" +
    "    <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "    <div class=\"col-xs-10 col-flush text-left\">\r" +
    "\n" +
    "        <div ng-messages=\"formRef[tfInputCtrlId].$error\"\r" +
    "\n" +
    "             class=\"has-error\">\r" +
    "\n" +
    "            <div ng-message=\"max\">{{:: 'Please enter a number less than 100.' | translate}}</div>\r" +
    "\n" +
    "            <div ng-message=\"min\">{{:: 'Please enter a number greater than 0.' | translate}}</div>\r" +
    "\n" +
    "            <div ng-message=\"maxlength\">{{:: 'Number of cannot exceed 2 characters.' | translate}}</div>\r" +
    "\n" +
    "            <div ng-if=\"timeFrameInputIsVisible\" ng-message=\"required\">{{:: 'Please enter a value.' | translate}}</div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<div class=\"row\" ng-if=\"formRef[calInputCtrlId].$error && formRef.isSubmitted\">\r" +
    "\n" +
    "    <div class=\"col-xs-2\"></div>\r" +
    "\n" +
    "    <div class=\"col-xs-10 col-flush text-left\">\r" +
    "\n" +
    "        <div ng-messages=\"formRef[calInputCtrlId].$error\"\r" +
    "\n" +
    "             class=\"has-error\">\r" +
    "\n" +
    "            <div ng-message=\"required\">{{:: 'Please enter a date.' | translate}}</div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/forms.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div id=\"form-results-panel\" class=\"panel panel-primary\" ng-class=\"(isModalDisplayed) ? 'hidden-print' : ''\">\r" +
    "\n" +
    "        <div ng-if=\"!loading && !httpError\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                {{::'Incomplete Forms' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div id=\"no-incomplete-forms-div\"\r" +
    "\n" +
    "                 class=\"text-center\"\r" +
    "\n" +
    "                 ng-if=\"!incompleteForms.length\">\r" +
    "\n" +
    "                {{::'No incomplete forms found.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"ap-margin-bottom-50\">\r" +
    "\n" +
    "                <div class=\"row panel-row\"\r" +
    "\n" +
    "                     id=\"incomplete-form-{{incompleteForm.RelSurveyPatientId}}\"\r" +
    "\n" +
    "                     ng-repeat=\"incompleteForm in incompleteForms track by $index\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <div>{{incompleteForm.QuestionnaireName}}</div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{::'Assigned' | translate}}\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{incompleteForm.EffectDate}}\"\r" +
    "\n" +
    "                                               format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <div ng-if=\"!incompleteForm.LastModifiedByPatient\">\r" +
    "\n" +
    "                            {{::'New' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <div ng-if=\"incompleteForm.LastModifiedByPatient\">\r" +
    "\n" +
    "                            <div>{{::'In Progress' | translate}}</div>\r" +
    "\n" +
    "                            {{::'Last Edited' | translate}}\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{incompleteForm.LastModifiedByPatient}}\"\r" +
    "\n" +
    "                                               format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default1 pull-right\" ng-click=\"openPatientQuestionnaire(incompleteForm)\">\r" +
    "\n" +
    "                            {{::'Complete Form' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                {{::'Completed Forms' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div id=\"no-complete-forms-div\"\r" +
    "\n" +
    "                 class=\"text-center\"\r" +
    "\n" +
    "                 ng-if=\"!completedForms.length\">\r" +
    "\n" +
    "                {{::'No completed forms found.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"ap-margin-bottom-50\">\r" +
    "\n" +
    "                <div class=\"row panel-row\"\r" +
    "\n" +
    "                 id=\"complete-form-{{completedForm.RelSurveyPatientId}}\"\r" +
    "\n" +
    "                 ng-repeat=\"completedForm in completedForms track by $index\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <div>{{completedForm.QuestionnaireName}}</div>\r" +
    "\n" +
    "                        <div>\r" +
    "\n" +
    "                            {{::'Assigned' | translate}}\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{completedForm.EffectDate}}\"\r" +
    "\n" +
    "                                               format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <div ng-if=\"completedForm.LastModifiedByPatient\">\r" +
    "\n" +
    "                            {{::'Submitted' | translate}}\r" +
    "\n" +
    "                            <ap-date-formatter date=\"{{completedForm.LastModifiedByPatient}}\"\r" +
    "\n" +
    "                                               format=\"date-time\"></ap-date-formatter>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"col-xs-4 col-xs-flush\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default1 pull-right\"\r" +
    "\n" +
    "                                ng-click=\"openPatientQuestionnaire(completedForm)\">\r" +
    "\n" +
    "                            {{::'Edit Form' | translate}}\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"panel-subheading\">\r" +
    "\n" +
    "                {{::'Practice Forms' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <span class=\"header-menu pull-right\">\r" +
    "\n" +
    "                <div class=\"dropdown-primary\" uib-dropdown>\r" +
    "\n" +
    "                    <button class=\"btn btn-default flush-right\" type=\"button\" id=\"subtype-filter-btn\" uib-dropdown-toggle>\r" +
    "\n" +
    "                        {{ 'Filter' | translate }}&nbsp;&nbsp;\r" +
    "\n" +
    "                        <span class=\"title-text\">{{ selectedFilterForm }}</span>\r" +
    "\n" +
    "                        <span class=\"caret\"></span>\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <ul class=\"dropdown-menu-right\" uib-dropdown-menu role=\"menu\">\r" +
    "\n" +
    "                        <li class=\"clickable\" role=\"presentation\" ng-repeat=\"filter in filterForm\">\r" +
    "\n" +
    "                            <a role=\"menuitem\" ng-click=\"filterPracticeForm(filter)\">{{ ::filter.Name }}</a>\r" +
    "\n" +
    "                        </li>\r" +
    "\n" +
    "                    </ul>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </span>\r" +
    "\n" +
    "            <div id=\"no-practice-forms-div\"\r" +
    "\n" +
    "                 class=\"text-center\"\r" +
    "\n" +
    "                 ng-if=\"!practiceFormsList.length\">\r" +
    "\n" +
    "                {{::'No practice forms found.' | translate}}\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "            <div class=\"row panel-row\"\r" +
    "\n" +
    "                 id=\"practice-form-{{practiceFormsList.RelPracticeFormPatientId}}\"\r" +
    "\n" +
    "                 ng-repeat=\"practiceForm in practiceFormsList track by $index\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"overflow-ellipsis col-xs-flush column-text col-xs-12 col-md-12\">\r" +
    "\n" +
    "                        {{practiceForm.PracticeFormName}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-class=\"(!practiceForm.isComplete) ? 'col-xs-12 col-xs-flush col-md-2' : 'col-xs-12 col-xs-flush col-md-3'\">\r" +
    "\n" +
    "                        <div class=\"overflow-ellipsis column-subtext\">\r" +
    "\n" +
    "                            <span>{{practiceForm.AttachmentTypeName}}</span>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-class=\"(!practiceForm.isComplete) ? 'col-xs-12 col-xs-flush col-md-5' : 'col-xs-12 col-xs-flush col-md-9'\">\r" +
    "\n" +
    "                        <div ng-class=\"(!practiceForm.isComplete) ? 'col-xs-12 col-xs-flush col-md-6 center-text' : 'col-xs-12 col-xs-flush col-md-5'\">\r" +
    "\n" +
    "                        <span ap-date-formatter date=\"{{practiceForm.EffectDate}}\" format=\"long-date\"></span>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-class=\"(!practiceForm.isComplete) ? 'col-xs-6 col-xs-flush col-md-3' : 'col-xs-6 col-xs-flush col-md-4'\">\r" +
    "\n" +
    "                        <button class=\"btn btn-default1\" ng-click=\"viewPracticeFormAttachment(practiceForm)\">{{:: 'View' | translate}}</button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div ng-class=\"(!practiceForm.isComplete) ? 'col-xs-6 col-xs-flush col-md-1' : 'col-xs-6 col-xs-flush col-md-2'\">\r" +
    "\n" +
    "                        <button ap-save-to-file=\"downloadPracticeFormAttachment(practiceForm)\">\r" +
    "\n" +
    "                            <i ng-show=\"!practiceForm.Downloading\" class=\"fa fa-download\"></i>\r" +
    "\n" +
    "                            <ap-spinner ng-show=\"practiceForm.Downloading\"></ap-spinner>\r" +
    "\n" +
    "                        </button>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"!practiceForm.Downloaded && !practiceForm.isComplete\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-md-4\">\r" +
    "\n" +
    "                        <div class=\"secondary-text-semi-bold-light\">\r" +
    "\n" +
    "                            <div class=\"label_wrap\">\r" +
    "\n" +
    "                                {{::'Please download and complete this form.'| translate }}\r" +
    "\n" +
    "                                <br/> {{::'Then upload your completed form.' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"practiceForm.Downloaded && practiceForm.isPending\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-md-5\">\r" +
    "\n" +
    "                        <div class=\"secondary-text-semi-bold-light\">\r" +
    "\n" +
    "                            <div class=\"label_wrap\">\r" +
    "\n" +
    "                                {{::'Upload successful.'| translate}}\r" +
    "\n" +
    "                                <br/> {{:: 'If you make changes to the form, you may upload it again.' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <ap-form-attachment ng-click=\"assignUploadForm(practiceForm)\" practice-form= 'practiceForm' attachment-dto= \"AttachmentList.attachmentDto\" sending=\"practiceForm.Uploading\">\r" +
    "\n" +
    "                        </ap-form-attachment>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div ng-if=\"practiceForm.Downloaded && !practiceForm.isPending\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush col-md-4\">\r" +
    "\n" +
    "                        <div class=\"secondary-text-semi-bold-light\">\r" +
    "\n" +
    "                            <div class=\"label_wrap\">\r" +
    "\n" +
    "                                {{::'Please complete the form.'| translate }}\r" +
    "\n" +
    "                                <br/> {{::'Then upload your completed form.' | translate}}\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                        <ap-form-attachment ng-click=\"assignUploadForm(practiceForm)\" practice-form= 'practiceForm' attachment-dto= \"AttachmentList.attachmentDto\" sending=\"practiceForm.Uploading\">\r" +
    "\n" +
    "                        </ap-form-attachment>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loading || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loading\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient questionnaire could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to view patient questionnaires.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/patientQuestionnaire.html',
    "<div ng-cloak>\r" +
    "\n" +
    "    <div class=\"panel panel-questionnaire\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <form name=\"patientQuestionnaireForm\" novalidate>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-show=\"loadingSection.loading\">\r" +
    "\n" +
    "                <div class=\"text-loading-section\">\r" +
    "\n" +
    "                    {{ ::'Loading Questionnaire Section' | translate }}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"text-center\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-show=\"savingQuestionnaire\">\r" +
    "\n" +
    "                <div class=\"text-loading-section\">\r" +
    "\n" +
    "                    {{ ::'Saving Patient Questionnaire' | translate }}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"text-center\">\r" +
    "\n" +
    "                    <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div ng-show=\"!httpError && !loadingSection.loading && !savingQuestionnaire\" class=\"panel-body panel-flush\">\r" +
    "\n" +
    "                <!-- TODO : Move section navigation into a custom directive ??? -->\r" +
    "\n" +
    "                <div class=\"panel-subheading-no-border-bottom\">\r" +
    "\n" +
    "                    <span>{{ ::patientQuestionnaire.Questionnaire.SurveyName }}</span>\r" +
    "\n" +
    "                    <span class=\"pull-right forms-sections-navigation\">\r" +
    "\n" +
    "                        {{ ::'Section' | translate}}\r" +
    "\n" +
    "                        {{ navigationSectionParams.currentSectionNumber }}\r" +
    "\n" +
    "                        {{ ::'of' | translate}}\r" +
    "\n" +
    "                        {{ patientQuestionnaire.Questionnaire.Sections.length }}\r" +
    "\n" +
    "                        <span ng-if=\"patientQuestionnaire.Questionnaire.Sections.length > 1\">\r" +
    "\n" +
    "                            <span class=\"clickable prev-nav\" ng-click=\"navMovePrevious()\">{{::'Prev' | translate}}</span>\r" +
    "\n" +
    "                            <span ng-repeat=\"section in patientQuestionnaire.Questionnaire.Sections | filter: { Visible: true }\">\r" +
    "\n" +
    "                                <span ng-click=\"displaySection(section)\">\r" +
    "\n" +
    "                                    <span ng-class=\"(section.SectionNumber === navigationSectionParams.currentSectionNumber)\r" +
    "\n" +
    "                                        ? 'clickable section-numbers section-number-current' : 'clickable section-numbers'\">\r" +
    "\n" +
    "                                            {{ section.SectionNumber }}\r" +
    "\n" +
    "                                    </span>\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                            </span>\r" +
    "\n" +
    "                            <span class=\"clickable next-nav\" ng-click=\"navMoveNext()\">{{::'Next' | translate}}</span>\r" +
    "\n" +
    "                        </span>\r" +
    "\n" +
    "                    </span>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"forms-header-validation-error\"\r" +
    "\n" +
    "                     ng-if=\"patientQuestionnaireForm.$invalid && patientQuestionnaireForm.isSubmitted\">\r" +
    "\n" +
    "                    {{ ::'Please correct form.' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <!--  <div class=\"forms-padding-top-10\"></div>  -->\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"panel-subheading\">\r" +
    "\n" +
    "                    {{ navigationSectionParams.currentSectionNumber }}.\r" +
    "\n" +
    "                    &nbsp;\r" +
    "\n" +
    "                    {{ navigationSectionParams.currentSectionName }}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"row row-question form-group\"\r" +
    "\n" +
    "                     ng-if=\"!patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].ContainsPatientHxQuestion\"\r" +
    "\n" +
    "                     ng-repeat=\"question in patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].Questions\"\r" +
    "\n" +
    "                     ng-class=\"{ 'has-error' : (patientQuestionnaireForm['SurveyQuestionId_' + question.SurveyQuestionId].$invalid\r" +
    "\n" +
    "                                                   && (patientQuestionnaireForm['SurveyQuestionId_' + question.SurveyQuestionId].$dirty\r" +
    "\n" +
    "                                                         || patientQuestionnaireForm.isSubmitted))}\"\r" +
    "\n" +
    "                     ng-init=\"loadingSection.loading=!$last\">\r" +
    "\n" +
    "                    <ap-form-question question=\"question\" form=\"patientQuestionnaireForm\"></ap-form-question>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-switch=\"(question.SurveyControlTypeName | uppercase)\">\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "                        <div ng-switch-when=\"RADIOBUTTON\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                <ap-form-answer-radiobutton\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        answer=\"answer\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-radiobutton>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "                        <div ng-switch-when=\"RADIOBUTTON\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <fieldset>\r" +
    "\n" +
    "                                <div ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                    <div class=\"row\" ng-if=\"$even\">\r" +
    "\n" +
    "                                        <div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 row-answer\"\r" +
    "\n" +
    "                                            ng-repeat=\"ans in [question.Answers[$index],question.Answers[$index + 1]]\"\r" +
    "\n" +
    "                                            ng-if=\"ans\">\r" +
    "\n" +
    "                                            <ap-form-answer-radiobutton\r" +
    "\n" +
    "                                                    form=\"patientQuestionnaireForm\"\r" +
    "\n" +
    "                                                    question=\"question\"\r" +
    "\n" +
    "                                                    answer=\"ans\"\r" +
    "\n" +
    "                                                    last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                            </ap-form-answer-radiobutton>\r" +
    "\n" +
    "                                        </div>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </fieldset>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "<!--\r" +
    "\n" +
    "                        <div ng-switch-when=\"CHECKBOX\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 row-answer\"  ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                <ap-form-answer-checkbox\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        answer=\"answer\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-checkbox>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "-->\r" +
    "\n" +
    "                        <div ng-switch-when=\"CHECKBOX\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div ng-repeat=\"answer in question.Answers\">\r" +
    "\n" +
    "                                <div class=\"row\" ng-if=\"$even\">\r" +
    "\n" +
    "                                    <div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 row-answer\"\r" +
    "\n" +
    "                                         ng-repeat=\"ans in [question.Answers[$index],question.Answers[$index + 1]]\"\r" +
    "\n" +
    "                                         ng-if=\"ans\">\r" +
    "\n" +
    "                                        <ap-form-answer-checkbox\r" +
    "\n" +
    "                                                form=\"patientQuestionnaireForm\"\r" +
    "\n" +
    "                                                question=\"question\"\r" +
    "\n" +
    "                                                answer=\"ans\"\r" +
    "\n" +
    "                                                last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                        </ap-form-answer-checkbox>\r" +
    "\n" +
    "                                     </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div ng-switch-when=\"TEXT\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                <ap-form-answer-text\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        answer=\"question.Answers[0]\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-text>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div ng-switch-when=\"TIMEFRAME\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                <ap-form-answer-timeframe\r" +
    "\n" +
    "                                        form=\"patientQuestionnaireForm\"\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-timeframe>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div ng-switch-when=\"NUMERIC\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                                <ap-form-answer-numeric\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        answers=\"question.Answers\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-numeric>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div ng-switch-when=\"DATE\" class=\"row\" ng-show=\"question.QuestionEnabled\">\r" +
    "\n" +
    "                            <div class=\"col-xs-4 row-answer\">\r" +
    "\n" +
    "                                <ap-form-answer-date\r" +
    "\n" +
    "                                        question=\"question\"\r" +
    "\n" +
    "                                        answer=\"question.Answers[0]\"\r" +
    "\n" +
    "                                        last-question=\"{{$last}}\">\r" +
    "\n" +
    "                                </ap-form-answer-date>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-8\"></div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"row row-question form-group\"\r" +
    "\n" +
    "                     ng-if=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].ContainsPatientHxQuestion\"\r" +
    "\n" +
    "                     ng-init=\"loadingSection.loading=true\"\r" +
    "\n" +
    "                     ng-switch=\"(patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].HistoryGroupId | uppercase)\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-switch-when=\"0238A133-904E-4E49-BDBA-4EB3CB3B39A7\" class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                            <ap-form-question-patient-problem-history\r" +
    "\n" +
    "                                questionnaire-section-id=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].SurveySectionId\"\r" +
    "\n" +
    "                                questionnaire-section=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1]\"\r" +
    "\n" +
    "                                loading=\"loadingSection.loading\">\r" +
    "\n" +
    "                            </ap-form-question-patient-problem-history>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-switch-when=\"A3FAF896-B328-4364-9621-012F8C6643BB\" class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                            <ap-form-question-family-history\r" +
    "\n" +
    "                                    questionnaire-section-id=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].SurveySectionId\"\r" +
    "\n" +
    "                                    questionnaire-section=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1]\"\r" +
    "\n" +
    "                                    loading=\"loadingSection.loading\">\r" +
    "\n" +
    "                            </ap-form-question-family-history>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div ng-switch-when=\"00000000-0000-0000-0000-000000000111\" class=\"row\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 row-answer\">\r" +
    "\n" +
    "                            <ap-form-question-immunization-history\r" +
    "\n" +
    "                                    questionnaire-section-id=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1].SurveySectionId\"\r" +
    "\n" +
    "                                    questionnaire-section=\"patientQuestionnaire.Questionnaire.Sections[navigationSectionParams.currentSectionNumber - 1]\"\r" +
    "\n" +
    "                                    loading=\"loadingSection.loading\">\r" +
    "\n" +
    "                            </ap-form-question-immunization-history>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"forms-footer-validation-error\"\r" +
    "\n" +
    "                     ng-if=\"patientQuestionnaireForm.$invalid && patientQuestionnaireForm.isSubmitted\">\r" +
    "\n" +
    "                    {{:: 'Please correct form.' | translate}}\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                <div class=\"forms-footer\">\r" +
    "\n" +
    "                    <button id=\"finish-later-btn\" class=\"btn btn-default1 pull-left\" ng-click=\"submitQuestionnaire('FINISH-LATER')\">\r" +
    "\n" +
    "                        {{:: 'Finish later' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <button id=\"next-section-btn\" name=\"next_section_btn\" class=\"btn btn-primary pull-right\" ng-click=\"navMoveNext()\">\r" +
    "\n" +
    "                        {{:: 'Next : ' | translate}} &nbsp; {{navigationSectionParams.nextSectionName}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"httpError\">\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.unhandled\" ng-cloak>\r" +
    "\n" +
    "                {{::'An error has occurred and the patient questionnaire could not be loaded.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <uib-alert type=\"danger\" ng-show=\"httpError.is403\" ng-cloak>\r" +
    "\n" +
    "                {{::'You do not have access to view patient questionnaires.' | translate}}\r" +
    "\n" +
    "            </uib-alert>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );


  $templateCache.put('/forms/views/updateFamilyHistoryModal.html',
    "<div class=\"modal-content modal-primary\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "    <form name=\"familyHistoryForm\" novalidate>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"modal-header\">\r" +
    "\n" +
    "            <button type=\"button\" class=\"close\" ng-click=\"cancel()\"><span>&times;</span></button>\r" +
    "\n" +
    "            <h4 class=\"modal-title\">{{::'Patient Family History' | translate}}</h4>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"modal-body\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'Relationship' | translate}}</label>\r" +
    "\n" +
    "                            <select class=\"form-control arrow-dropdown\"\r" +
    "\n" +
    "                                    name=\"relationshipSelect\"\r" +
    "\n" +
    "                                    id=\"relationshipSelect\"\r" +
    "\n" +
    "                                    ng-model=\"FamilyHistoryAnswer.RelationshipId\"\r" +
    "\n" +
    "                                    ng-change=\"relationshipSelect()\"\r" +
    "\n" +
    "                                    ng-required=\"true\"\r" +
    "\n" +
    "                                    ng-options=\"relationshipType.ItemId as relationshipType.Name for relationshipType in familyHxRelationshipList | filter: {IsVisible: true}\">\r" +
    "\n" +
    "                            </select>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row\" ng-if=\"familyHistoryForm.relationshipSelect.$error && familyHistoryForm.isSubmitted\">\r" +
    "\n" +
    "                        <div ng-messages=\"familyHistoryForm.relationshipSelect.$error\"\r" +
    "\n" +
    "                             class=\"has-error\">\r" +
    "\n" +
    "                            <div ng-message=\"required\">{{:: 'Please select family relationship.' | translate}}</div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <div class=\"ap-radio-wrapper ap-radio-inline ap-radio-flush\">\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   type=\"radio\"\r" +
    "\n" +
    "                                   name=\"relationshipQualifier\"\r" +
    "\n" +
    "                                   id=\"isMaternal\"\r" +
    "\n" +
    "                                   ng-model=\"Model.RelationshipQualifier\"\r" +
    "\n" +
    "                                   ng-value=\"RelationshipQualifier.isMaternal\">\r" +
    "\n" +
    "                            <label for=\"isMaternal\">{{:: 'Maternal' | translate}}</label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-radio-wrapper ap-radio-inline ap-radio-flush\">\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   type=\"radio\"\r" +
    "\n" +
    "                                   name=\"relationshipQualifier\"\r" +
    "\n" +
    "                                   id=\"isPaternal\"\r" +
    "\n" +
    "                                   ng-model=\"Model.RelationshipQualifier\"\r" +
    "\n" +
    "                                   ng-value=\"RelationshipQualifier.isPaternal\">\r" +
    "\n" +
    "                            <label for=\"isPaternal\">{{:: 'Paternal' | translate}}</label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <div class=\"ap-radio-wrapper ap-radio-inline ap-radio-flush\">\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   type=\"radio\"\r" +
    "\n" +
    "                                   name=\"relationshipQualifier\"\r" +
    "\n" +
    "                                   id=\"isUnknown\"\r" +
    "\n" +
    "                                   ng-model=\"Model.RelationshipQualifier\"\r" +
    "\n" +
    "                                   ng-value=\"RelationshipQualifier.isUnknown\">\r" +
    "\n" +
    "                            <label for=\"isUnknown\">{{:: 'Unknown' | translate}}</label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"ap-radio-wrapper ap-radio-inline ap-radio-flush\">\r" +
    "\n" +
    "                            <input class=\"form-control\"\r" +
    "\n" +
    "                                   type=\"radio\"\r" +
    "\n" +
    "                                   name=\"relationshipQualifier\"\r" +
    "\n" +
    "                                   id=\"isNone\"\r" +
    "\n" +
    "                                   ng-model=\"Model.RelationshipQualifier\"\r" +
    "\n" +
    "                                   ng-value=\"RelationshipQualifier.none\">\r" +
    "\n" +
    "                            <label for=\"isNone\">{{:: 'None' | translate}}</label>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'First Name' | translate}}</label>\r" +
    "\n" +
    "                        <input class=\"form-control\"\r" +
    "\n" +
    "                               id=\"firstName\"\r" +
    "\n" +
    "                               name=\"firstName\"\r" +
    "\n" +
    "                               ng-model=\"FamilyHistoryAnswer.FirstName\"\r" +
    "\n" +
    "                               type=\"text\"\r" +
    "\n" +
    "                               placeholder=\"First name goes here\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'Last Name' | translate}}</label>\r" +
    "\n" +
    "                        <input class=\"form-control\"\r" +
    "\n" +
    "                               id=\"lastName\"\r" +
    "\n" +
    "                               name=\"lastName\"\r" +
    "\n" +
    "                               ng-model=\"FamilyHistoryAnswer.LastName\"\r" +
    "\n" +
    "                               type=\"text\"\r" +
    "\n" +
    "                               placeholder=\"Last name goes here\">\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                    <div class=\"row form-group text-right\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'Birthdate' | translate}}</label>\r" +
    "\n" +
    "                        <ap-time-frame\r" +
    "\n" +
    "                            time-frame-id=\"Model.TimeFrameIdBirthdate\"\r" +
    "\n" +
    "                            time-frame-answer=\"FamilyHistoryAnswer.BirthDateTimeFrame\"\r" +
    "\n" +
    "                            time-frame-selected-callback=\"\"\r" +
    "\n" +
    "                            required>\r" +
    "\n" +
    "                        </ap-time-frame>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                    <div class=\"row form-group text-right\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'Death Date' | translate}}</label>\r" +
    "\n" +
    "                        <ap-time-frame\r" +
    "\n" +
    "                                time-frame-id=\"Model.TimeFrameIdDeathdate\"\r" +
    "\n" +
    "                                time-frame-answer=\"FamilyHistoryAnswer.DeathDateTimeFrame\"\r" +
    "\n" +
    "                                time-frame-selected-callback=\"\"\r" +
    "\n" +
    "                                required>\r" +
    "\n" +
    "                        </ap-time-frame>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row ap-margin-bottom-20\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                    <div class=\"row form-group\">\r" +
    "\n" +
    "                        <label class=\"control-label\">{{:: 'Notes' | translate}}</label>\r" +
    "\n" +
    "                        <textarea\r" +
    "\n" +
    "                            class=\"form-control\"\r" +
    "\n" +
    "                            id=\"notes\"\r" +
    "\n" +
    "                            name=\"notes\"\r" +
    "\n" +
    "                            ng-model=\"FamilyHistoryAnswer.Notes\"\r" +
    "\n" +
    "                            placeholder=\"{{ ::'Notes here' | translate }}\"\r" +
    "\n" +
    "                            rows=\"2\">\r" +
    "\n" +
    "                        </textarea>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <!-- <div class=\"forms-vertical-space-20\"></div> -->\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-flush family-history-line\"></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"family-history-problem-header row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                    <h4 class=\"modal-title\">{{:: 'Please select all that apply.' | translate}}</h4>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class=\"col-xs-12\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12\">\r" +
    "\n" +
    "                        <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-striped-left\">\r" +
    "\n" +
    "                                <span class=\"pull-left\">\r" +
    "\n" +
    "                                    <label class=\"label-text\">{{:: 'Disease' | translate}}</label>\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"col-xs-6 col-striped-right\">\r" +
    "\n" +
    "                                <span class=\"pull-right\">\r" +
    "\n" +
    "                                    <label class=\"label-text\">{{:: 'Onset Date' | translate}}</label>\r" +
    "\n" +
    "                                </span>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                    <div class=\"col-xs-12 body-line\">\r" +
    "\n" +
    "                        <div ng-if=\"!FamilyHistoryAnswer.ProblemHistoryAnswers.length\">\r" +
    "\n" +
    "                            {{::'There are no diseases associated with the Patient Family History section.' | translate}}\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "                        <div class=\"striped col-xs-12 col-flush\" ng-repeat=\"problemHistoryAnswer in FamilyHistoryAnswer.ProblemHistoryAnswers\">\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-left\">\r" +
    "\n" +
    "                                    <input type=\"checkbox\"\r" +
    "\n" +
    "                                           class=\"form-control\"\r" +
    "\n" +
    "                                           name=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                           id=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                           ng-model=\"problemHistoryAnswer.Selected\"\r" +
    "\n" +
    "                                           ng-disabled=\"problemHistoryAnswer.CameFromPatientChart\">\r" +
    "\n" +
    "                                    <label class=\"label-text\"\r" +
    "\n" +
    "                                           ng-class=\"problemHistoryAnswer.CameFromPatientChart ? 'disabled' : ''\"\r" +
    "\n" +
    "                                           for=\"disease_selected_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\">&nbsp;&nbsp;{{ problemHistoryAnswer.DiseaseName }}</label>\r" +
    "\n" +
    "                                    <span ng-show=\"problemHistoryAnswer.CameFromPatientChart\">&nbsp;{{'(Already On Chart)' | translate}}</span>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                                <div class=\"col-xs-6 col-flush-right\">\r" +
    "\n" +
    "                                    <ap-time-frame\r" +
    "\n" +
    "                                            time-frame-id=\"problemHistoryAnswer.ProblemHistoryAnswerId\"\r" +
    "\n" +
    "                                            time-frame-answer=\"problemHistoryAnswer.OnsetTimeFrame\"\r" +
    "\n" +
    "                                            time-frame-selected-callback=\"timeFrameSelectedCallback(timeFrameId,onsetTimeFrameId)\"\r" +
    "\n" +
    "                                            disabled=\"problemHistoryAnswer.CameFromPatientChart\"\r" +
    "\n" +
    "                                            required>\r" +
    "\n" +
    "                                    </ap-time-frame>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                            <div class=\"row\">\r" +
    "\n" +
    "                                <div class=\"col-xs-12 col-flush\">\r" +
    "\n" +
    "                                    <div class=\"row form-group\">\r" +
    "\n" +
    "                                        <label class=\"control-label\">{{:: 'Notes' | translate}}</label>\r" +
    "\n" +
    "                                        <textarea\r" +
    "\n" +
    "                                            class=\"form-control\"\r" +
    "\n" +
    "                                            id=\"notes_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                            name=\"notes_{{problemHistoryAnswer.ProblemHistoryAnswerId}}\"\r" +
    "\n" +
    "                                            ng-model=\"problemHistoryAnswer.Notes\"\r" +
    "\n" +
    "                                            placeholder=\"{{ ::'Notes here' | translate }}\"\r" +
    "\n" +
    "                                            ng-disabled=\"problemHistoryAnswer.CameFromPatientChart\"\r" +
    "\n" +
    "                                            rows=\"1\">\r" +
    "\n" +
    "                                        </textarea>\r" +
    "\n" +
    "                                    </div>\r" +
    "\n" +
    "                                </div>\r" +
    "\n" +
    "                            </div>\r" +
    "\n" +
    "                        </div>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div ng-if=\"loadingModal || httpError\">\r" +
    "\n" +
    "            <div class=\"text-center\" ng-show=\"loadingReceipt\">\r" +
    "\n" +
    "                <ap-spinner size=\"3\"></ap-spinner>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"modal-footer\">\r" +
    "\n" +
    "            <div class=\"row\">\r" +
    "\n" +
    "                <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "            <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button type=\"button\" class=\"btn btn-default1\" ng-click=\"cancel()\">\r" +
    "\n" +
    "                        {{:: 'Cancel' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class=\"col-xs-4\">\r" +
    "\n" +
    "                    <button class=\"btn btn-primary\"\r" +
    "\n" +
    "                            ng-click=\"accept()\">\r" +
    "\n" +
    "                        {{::'Update History' | translate}}\r" +
    "\n" +
    "                    </button>\r" +
    "\n" +
    "                    <div class=\"has-error text-center\"\r" +
    "\n" +
    "                         ng-if=\"familyHistoryForm.$invalid && familyHistoryForm.isSubmitted\">\r" +
    "\n" +
    "                        {{ ::'Please correct form.' | translate}}\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "                <div class = \"col-xs-2\"></div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </form>\r" +
    "\n" +
    "\r" +
    "\n" +
    "</div>\r" +
    "\n"
  );

}]);
